import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class SalutationsService {
  private salutations = [
    {
      key: 'mr',
      nameKey: 'salutation_mr',
      name: '',
    },
    {
      key: 'ms',
      nameKey: 'salutation_ms',
      name: '',
    },
  ];

  constructor(private translate: TranslateService) {
    this.salutations.forEach(salutation => {
      this.translate.get(salutation.nameKey).subscribe(name => {
        salutation.name = name;
      });
    });
  }

  get() {
    return this.salutations;
  }
}
